// USER RESUME Price ***************************************************************************
// pathname: /v1/resume-operation/{userSlug}/price
// ************************************************************************************************
import {
  useSwrApi,
} from 'src/hooks/useSwrApi';


interface UserSwrGetPriceProps {
  locale: string,
  userSlug: string,
  shouldFetch?: boolean
}


/**
 * @description SWR: fetch user resume comments.
 * * **locale**: string - the locale to use for the request. Default 'ro'.
 * * **userSlug**: string - the user slug to get the comments for.
 */
export const useSwrResumeGetPrice = (props: UserSwrGetPriceProps) => {
  // Props destructuring
  const {
    locale = 'ro',
    userSlug,
    shouldFetch = true,
  } = props;


  // SWR: fetch data
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'ResumePrice'>[]>({
    url: `/v1/resume-operation/${userSlug}/price`,
    locale,
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
      dedupingInterval: 1000 * 60 * 5, // 5 minutes
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
